import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // Initialize with token from localStorage or null
  private tokenSubject = new BehaviorSubject<string | null>(localStorage.getItem('auth_token'));
  
  // Public observable for token changes
  token$: Observable<string | null> = this.tokenSubject.asObservable();

  // Check if user is logged in (token present)
  get isLoggedIn(): boolean {
    return !!this.tokenSubject.value;
  }

  // Method to set token (login)
  setToken(token: string): void {
    localStorage.setItem('auth_token', token);
    console.log(token)
    this.tokenSubject.next(token);
  }

  // Method to clear token (logout)
  clearToken(): void {
    localStorage.removeItem('auth_token');
    this.tokenSubject.next(null);
  }

  // Optional: Get current token value synchronously
  getToken(): string | null {
    return this.tokenSubject.value;
  }
}
